import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import {
  Backdrop,
  Badge,
  Box,
  CircularProgress,
  Grid,
  Grid2,
  useMediaQuery,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useTheme } from "@emotion/react";
import { LabelText } from "./MenuListCardsComponent";

import { useDispatch, useSelector } from "react-redux";
import {
  IMG_BASE_URL,
  format_Number,
  getCompanyStatus,
  getHeight,
  validateSupplements,
} from "../../utils/utils";
import {
  UpdateAddToCartProducts,
  setNextProduct,
  setOpenCart,
  setSupplementError,
  setSupplementInfo,
  setWebshopRelatedProductsInfo,
} from "../../store/slice/Webshop.slice";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import dayjs from "dayjs";
import SimpleCarousel from "./ImageCarousel";
import WebshopAccordian from "./WebshopAccordian";
import Tags from "./Tags";
import { FetchWebshopProductsInfo } from "../../api/Webshop.service";
import { useLocation, useNavigate } from "react-router-dom";
import ProductImageCard from "./ImageCarousel";

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function AddToCart() {
  const {
    languageWords,
    webShopProductInfo,
    itemCount,
    supplementsInfo,
    selectedProduct,
    addToCartProducts,
    reletedProductsInfo,
    defaultLanguage,
    supplementError,
    CurrencyData,
    webShopMenuPosition,
    webshopOpeningHours,
    deliveryType,
  } = useSelector((store) => store?.Webshop);
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const addtocartCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "ProductDetailScreen"
  )?.fields
  const supplementCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Supplements"
  )?.fields
  const BtnCss= css?.find((item)=> item?.cssTabFieldsGroupName === "Overall Webshop")?.fields;
  const [imgError, setImgError] = React.useState(false);
  const contentRef = React.useRef(null);

  const location = useLocation();
  const recommededProducts = location.state;
  const navigate = useNavigate();
  const { key, resType } = useSelector((store) => store?.widgetSettings);

  const currentDate = dayjs();
  const specialPrice = selectedProduct?.specialPriceFields?.find((price) =>
    currentDate.isBetween(
      dayjs(price.specialpricefrom, "DD-MM-YYYY"),
      dayjs(price.specialpriceto, "DD-MM-YYYY"),
      null,
      "[]"
    )
  );
  const [selectedSupplements, setSelectedSupplements] =
    React.useState(supplementsInfo);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const imageDatas = webShopProductInfo?.data?.additionalImageFiles || [];
  const additionalFields = webShopProductInfo?.data?.additionalFields || [];
  const [tags, setTags] = React.useState([]);
  const [opens, setOpens] = React.useState(false);
  const [caroImg, setCaroImg] = React.useState(false);
  const handleClosebackdrop = () => {
    setOpens(false);
  };

  const handleChildData = (value) => {
    setCaroImg(value);
  };
  const isNullValue = (value) => value === null || value === "null";

  const handleAddToCart = (data) => {
    const err = validateSupplements(
      selectedProduct,
      supplementsInfo,
      webShopProductInfo,
      setSupplementError,
      dispatch,
      recommededProducts
    );

    if (Object.keys(err || {}).length > 0) return;

    const existingProduct = addToCartProducts?.find(
      (prod) => prod.idproduct === data.idproduct
    );

    if (!existingProduct) {
      dispatch(
        UpdateAddToCartProducts({
          ...data,
          prodCount: itemCount[data?.idproduct],
          recommededProducts,
        })
      );
    }
    if (recommededProducts) {
      const cartUrl = !isNullValue(webShopMenuPosition)
        ? "/webshopMenuItem/cartdetail"
        : "/cartdetail";

      navigate(cartUrl, { state: recommededProducts });

      dispatch(setNextProduct(true));
      setTimeout(handleClose, 50);
      return;
    }
    const recommendedUrl = !isNullValue(webShopMenuPosition)
      ? "/webshopMenuItem/recommendedProduct"
      : "/recommendedProduct";
    if (Array.isArray(reletedProductsInfo) && reletedProductsInfo.length > 0) {
      navigate(recommendedUrl);
    } else {
      dispatch(setOpenCart(true));
      setTimeout(handleClose, 50);
      const cartURL = !isNullValue(webShopMenuPosition)
        ? "/webshopMenuItem/cartdetail"
        : "/cartdetail";
      navigate(cartURL);
    }

    dispatch(setNextProduct(true));
  };
  const supplementTitles = {
    supplementProductsDetails1: "Supplement 1",
    supplementProductsDetails2: "Supplement 2",
    supplementProductsDetails3: "Supplement 3",
  };

  const ProductPrice = (id, productPrice) => {
    const supplementInfo = supplementsInfo?.find(
      (item) => item?.idproduct == id
    );

    const supplementTotal =
      supplementInfo?.supplements?.reduce(
        (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
        0
      ) || 0;

    const productTotal = productPrice * (itemCount[id] || 0) + supplementTotal;
    if (productTotal <= 0) return null;
    return format_Number(productTotal);
  };

  React.useEffect(() => {
    if (!webShopProductInfo?.data) return;

    const tags = Object.keys(webShopProductInfo.data)
      .filter((key) => key.startsWith("tagText"))
      .map((key) => {
        const index = key.replace("tagText", "");
        return {
          text: webShopProductInfo.data[key],
          bgColor:
            webShopProductInfo.data[`tagBackgroundColor${index}`] || "#007bff",
          textColor: webShopProductInfo.data[`tagColor${index}`] || "#fff",
        };
      })
      .filter((tag) => tag.text);

    setTags(tags);
  }, [webShopProductInfo]);

  React.useEffect(() => {
    if (!webShopProductInfo?.data) return;
    const recommededProductIds = webShopProductInfo?.data?.relatedProducts;
    const getProductsInfo = async (
      key,
      defaultLanguage,
      webShopProductList
    ) => {
      setOpens(true);
      try {
        const productInfo = await Promise.all(
          webShopProductList.map(async (item) => {
            const productDataDetails = await FetchWebshopProductsInfo(
              key,
              defaultLanguage,
              item
            );
            return productDataDetails?.data;
          })
        );

        if (!productInfo) {
          console.error("Error fetching product list:", productInfo);
        } else {
          dispatch(setWebshopRelatedProductsInfo(productInfo));
        }
        setOpens(false);
      } catch (error) {
        console.error("Error fetching product list:", error);
        setOpens(false);
      }
    };
    getProductsInfo(key, defaultLanguage, recommededProductIds);
  }, [webShopProductInfo]);
  React.useEffect(() => {
    validateSupplements(
      selectedProduct,
      supplementsInfo,
      webShopProductInfo,
      setSupplementError,
      dispatch,
      recommededProducts
    );
  }, [supplementsInfo]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleBadgeClick = (productId, supplementItem, detailsKey) => {
    setSelectedSupplements((prev) => {
      const productIndex = prev.findIndex(
        (product) => product.idproduct === productId
      );

      if (productIndex > -1) {
        const existingProduct = prev[productIndex];
        const existingSupplements = existingProduct.supplements || [];
        const isAlreadyAdded = existingSupplements.some(
          (item) =>
            item.idwebshopsupplementitem ===
              supplementItem.idwebshopsupplementitem &&
            item.detailsKey === detailsKey
        );

        if (isAlreadyAdded) {
          const updatedSupplements = existingSupplements.filter(
            (item) =>
              item.idwebshopsupplementitem !==
                supplementItem.idwebshopsupplementitem ||
              item.detailsKey !== detailsKey
          );
          if (updatedSupplements.length === 0) {
            return prev.filter((_, index) => index !== productIndex);
          }
          return prev.map((product, index) =>
            index === productIndex
              ? { ...product, supplements: updatedSupplements }
              : product
          );
        } else {
          return prev.map((product, index) =>
            index === productIndex
              ? {
                  ...product,
                  supplements: [
                    ...existingSupplements,
                    { ...supplementItem, detailsKey },
                  ],
                }
              : product
          );
        }
      } else {
        return [
          ...prev,
          {
            idproduct: productId,
            supplements: [{ ...supplementItem, detailsKey }],
          },
        ];
      }
    });
  };

  React.useEffect(() => {
    //if (selectedSupplements.length > 0)
    dispatch(setSupplementInfo([...selectedSupplements]));
  }, [selectedSupplements]);

  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };
  const sendHeight = React.useCallback(() => {
    if (!contentRef.current) return;

    const height = contentRef.current.scrollHeight;

    send(`${height}px`, "100%", "", "0px", "0px", "", "relative");
  }, []);

  React.useLayoutEffect(() => {
    if (!contentRef.current) return;
    sendHeight();
    requestAnimationFrame(sendHeight);
    const images = contentRef.current.querySelectorAll("img");
    images.forEach((img) => {
      if (!img.complete) {
        img.onload = sendHeight;
      }
    });
  }, [webShopProductInfo, selectedProduct, supplementsInfo, caroImg]);
  if (opens) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={opens}
        onClick={handleClosebackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  return (
    <div style={{ width: "100%" }}>
      {!isNullValue(webShopMenuPosition) &&
        !getCompanyStatus(
          webshopOpeningHours?.value?.data?.openTime,
          webshopOpeningHours?.value?.data?.closeTime,
          webshopOpeningHours?.value?.data?.companyOpen,
          webshopOpeningHours?.value?.data?.deliveryFrom,
          webshopOpeningHours?.value?.data?.deliveryTo,
          webshopOpeningHours?.value?.data?.delivery,
          deliveryType
        )?.status && (
          <Box
            sx={{
              width: "100%",

              backgroundColor: "#fff3f3",
              borderBottom: "1px solid #f44336",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
           
            }}
          >
            <Typography
              sx={{
                color: "#c62828",
                fontWeight: 600,
                fontSize: "1.1rem",
                fontFamily: "Roboto, sans-serif",
                letterSpacing: "0.5px",
              }}
            >
              {
                getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.message
              }
            </Typography>
          </Box>
        )}
      <Box
        ref={contentRef}
        sx={{
          width:
            webShopMenuPosition == "vertical"
              ? isSmallScreen
                ? `calc(100% - 65px)`
                : `calc(100% - 120px)`
              : "100%",
          backgroundColor: addtocartCss?.productDetailBgClr,
          minHeight:"100%",
          ml:
            webShopMenuPosition === "vertical"
              ? isSmallScreen
                ? "60px"
                : "120px"
              : 0,
        p:2,
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
          position: "relative",
          transition: "all 0.3s ease-in-out",

          display: "flex",
          flexDirection: "column",
          gap: 3,

          "&:hover": {
            boxShadow: "0 12px 28px rgba(0,0,0,0.1)",
          },
        }}
      >
        <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <Box>
            <IconButton
              color="warning"
              onClick={() =>
                navigate(
                  !isNullValue(webShopMenuPosition)
                    ? "/webshopMenuItem"
                    : "/menu"
                )
              }
              sx={{
                backgroundColor: "#fff8e1",
                borderRadius: 2,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                "&:hover": {
                  backgroundColor: "#ffe082",
                },
              }}
            >
              <ArrowBackIosNewRoundedIcon
                sx={{ fontSize: { xs: 20, sm: 24, md: 28 } }}
              />
            </IconButton>
          </Box>
          <Typography
            sx={{
              color: addtocartCss?.
              productDetailHeadingClr
              ,
              fontWeight: 700,
              fontSize: isSmallScreen ? "1.4rem" : "2rem",
              m: 2,
            }}
          >
            {selectedProduct?.displayname || selectedProduct?.displayName}
          </Typography>
        </Box>
        <Grid2 container spacing={2} >
          {!caroImg && (
            <Grid2
              size={{ md: 4, sm: 12, xs: 12 }}
              sx={{ position: "relative" }}
            >
              {webShopProductInfo?.data?.labelText && (
                <LabelText
                  label={webShopProductInfo?.data?.labelText}
                  color={webShopProductInfo?.data?.labelColor}
                  bgColor={webShopProductInfo?.data?.labelBackgroundColor}
                  top={24}
                  left={20}
                />
              )}
              {!imageDatas ||
              (Array.isArray(imageDatas)
                ? imageDatas.length === 0
                : typeof imageDatas === "string" &&
                  imageDatas.trim() === "") ? (
                    <Box
                    sx={{
                      width: "100%",
                      maxWidth: 600,
                      mx: "auto",
                      borderRadius: 4,
                      overflow: "hidden",
                      backgroundColor: "#F9F8F6",
                      padding:2
                    }}
                  >
                    {/* Image */}
                    {selectedProduct?.imagefilename && (
                      <Box
                        sx={{
                          width: "100%",
                          aspectRatio: "4 / 3", // better natural ratio
                          overflow: "hidden",
                          backgroundColor: "#f5f5f5",
                          borderRadius: 4,
                        }}
                      >
                        <img
                          src={`${IMG_BASE_URL}/upload/WebshopProduct${selectedProduct.imagefilename?.replace(
                            /\\/g,
                            "/"
                          )}`}
                          alt="menu_item_img"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain", // show full image
                          }}
                          onError={(e) => {
                            setImgError(true);
                            e.target.style.display = "none";
                          }}
                        />
                      </Box>
                    )}
                  
                    {/* Description */}
                    {selectedProduct?.info && (
                      <Typography
                        sx={{
                          p: 2,
                          fontSize: "14px",
                          color: "#616161",
                          lineHeight: 1.6,
                        }}
                      >
                        {selectedProduct?.info}
                      </Typography>
                    )}
                  
                    {/* Tags */}
                    {tags?.length > 0 && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 16,
                          right: 16,
                        }}
                      >
                        <Tags tags={tags} />
                      </Box>
                    )}
                  </Box>
              ) : (
                <Box sx={{ width: "100%" }}>
                  <SimpleCarousel
                    slides={imageDatas}
                    tags={tags}
                    handleChildData={handleChildData}
                    info={selectedProduct?.info}
                    infoClr={addtocartCss?.productDetailInfoClr}
                    bgClr={addtocartCss?.productImgBgClr}
                  />
                </Box>
              )}
            </Grid2>
          )}

          <Grid2 size={{ md: 8, sm: 12, xs: 12 }}>
          {[
            "supplementProductsDetails1",
            "supplementProductsDetails2",
            "supplementProductsDetails3",
          ]?.some(
            (detailsKey) => webShopProductInfo?.data?.[detailsKey]?.length > 0
          ) && (
              <Box
            
              >
                {[
                  "supplementProductsDetails1",
                  "supplementProductsDetails2",
                  "supplementProductsDetails3",
                ].map((detailsKey, idx) => {
                  const supplements = webShopProductInfo?.data?.[detailsKey];
                  if (!supplements || supplements.length === 0) return null;

                  return (
                    <Box key={idx} sx={{ mb: 3 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          mb: 2,
                          fontWeight: 700,
                          fontSize: { xs: "16px", sm: "18px" },
                          color: supplementCss?.SupplementHeadingClr,
                        }}
                      >
                        {supplementTitles[detailsKey]}
                      </Typography>

                      
                       <Box
                       sx={{
                         display: "grid",
                         gridTemplateColumns: {
                           xs: "repeat(2, 1fr)",   // 2 per row mobile
                           sm: "repeat(3, 1fr)",   // 3 per row tablet
                           md: "repeat(4, 1fr)",   // 4 per row desktop (max 4)
                         },
                         gap: 2,
                       }}
                     >
                      
                        {supplements.map((type, index) => {
                          if (type?.price < 0) return null;

                          const isSelected = selectedSupplements
                            ?.find(
                              (supplement) =>
                                supplement?.idproduct ===
                                selectedProduct?.idproduct
                            )
                            ?.supplements?.some(
                              (supp) =>
                                supp?.idwebshopsupplementitem ===
                                  type?.idwebshopsupplementitem &&
                                supp?.detailsKey === detailsKey
                            );

                          return (
                            <Badge
                              key={index}
                              variant="outlined"
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                height: 60 ,
                                borderRadius: "14px",
                                border: `1.5px solid ${isSelected ? supplementCss?.SupplementHighLightBgClr : supplementCss?.SupplementBorderClr }`,
                                color: isSelected ? supplementCss?.
                                SupplementHighlightTxtClr
                                 :supplementCss?.SupplementTxtClr ??  "#344054",
                                backgroundColor: isSelected ? supplementCss?.SupplementHighLightBgClr : supplementCss?.SupplementBgClr,
                                boxShadow: isSelected
                                  ? "0 6px 16px rgba(243, 113, 32, 0.25)"
                                  : "0 2px 6px rgba(0,0,0,0.04)",
                                transition: "all 0.25s ease",
                                cursor: "pointer",
                                textAlign: "center",
                                fontSize: "0.85rem",
                                px: 1,
                                py: 1,
                                "&:hover": {
                                  borderColor: "#F37120",
                                  backgroundColor: supplementCss?.SupplementBadgeHoverClr
                                  ,
                                  transform: "translateY(-2px)",
                                  boxShadow: "0 6px 14px rgba(243, 113, 32, 0.18)",
                                },
                              }}
                              onClick={() => {
                                handleBadgeClick(
                                  selectedProduct.idproduct,
                                  type,
                                  detailsKey
                                );
                                validateSupplements(
                                  selectedProduct,
                                  supplementsInfo,
                                  webShopProductInfo,
                                  setSupplementError,
                                  dispatch,
                                  recommededProducts
                                );
                              }}
                            >
                              <Box>
                                <Typography
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: "0.85rem",
                                    mt: 0.3,
                                  }}
                                >
                                  {type?.displayName}
                                </Typography>
                                {type?.price > 0 && (
                                  <Typography
                                    sx={{
                                      fontWeight: 500,
                                      fontSize: "0.85rem",
                                      mt: 0.3,
                                    }}
                                  >
                                    {CurrencyData?.value?.currencySymbol}
                                    {type?.price && format_Number(type?.price)}
                                  </Typography>
                                )}
                              </Box>
                            </Badge>
                          );
                        })}
                      </Box>
                    </Box>
                  );
                })}

                {Object.keys(supplementError)?.length > 0 && (
                  <Typography
                    sx={{ color: "error.main", textAlign: "center", mt: 2 }}
                  >
                    {supplementError?.message}
                  </Typography>
                )}
              </Box>
        
          )}
          </Grid2>
    
        </Grid2>
        <Box
          sx={{
            position: "fixed",
            top: 16, // distance from top
            alignSelf: "flex-end", // push to right in flex column
            zIndex: 1400,
            width: "fit-content",
          }}
        >
          <Button
            size="medium"
            onClick={() => handleAddToCart(selectedProduct)}
            variant="contained"
            sx={{
              width: 200,
              borderRadius: "12px",
              background: BtnCss?.ButtonBgClr ?? "linear-gradient(135deg, #F37120 0%, #FF9F45 100%)",
              color: BtnCss?.
              ButtonTxtClr,
              boxShadow: "0 6px 20px rgba(243, 113, 32, 0.3)",
              textTransform: "none",
              px: 2,
              py: 1.6,
              transition: "all 0.3s ease",
              "&:hover": {
                background: "linear-gradient(135deg, #FF8120 0%, #FFB564 100%)",
                transform: "translateY(-2px)",
                boxShadow: "0 10px 24px rgba(243, 113, 32, 0.35)",
              },
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 1.5,
            }}
            disabled={
              [
                "supplementProductsDetails1",
                "supplementProductsDetails2",
                "supplementProductsDetails3",
              ]?.some(
                (detailsKey) =>
                  webShopProductInfo?.data?.[detailsKey]?.length > 0
              ) && Object.keys(supplementError).length > 0
            }
          >
            <ShoppingCartIcon sx={{ color: BtnCss?.ButtonIconClr, fontSize: 28 }} />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                flex: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  color: "#fff",
                }}
              >
                {languageWords?.AddToCart}
              </Typography>

              {specialPrice &&
                ProductPrice(
                  selectedProduct?.idproduct,
                  selectedProduct.price
                ) && (
                  <Typography
                    variant="body2"
                    sx={{
                      textDecoration: "line-through",
                      color: "rgba(255,255,255,0.75)",
                      fontSize: "0.8rem",
                      lineHeight: 1,
                    }}
                  >
                    {CurrencyData?.value?.currencySymbol}
                    {ProductPrice(
                      selectedProduct?.idproduct,
                      selectedProduct.price
                    )}
                  </Typography>
                )}

              {(() => {
                const finalPrice = ProductPrice(
                  selectedProduct?.idproduct,
                  specialPrice
                    ? specialPrice.specialprice
                    : recommededProducts
                    ? selectedProduct?.relatedproductprice
                    : selectedProduct.price
                );

                return (
                  finalPrice && (
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        fontSize: "1.2rem",
                        color: "#fff",
                        lineHeight: 1.2,
                      }}
                    >
                      {CurrencyData?.value?.currencySymbol}
                      {finalPrice}
                    </Typography>
                  )
                );
              })()}
            </Box>
          </Button>
        </Box>

        <Box sx={{ mt: 2 }}>
          <WebshopAccordian data={additionalFields} />
        </Box>
      </Box>
    </div>
  );
}
